import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EngagementModule } from './engagement/engagement.module';
import { QuickRepliesModule } from './quick-replies/quick-replies.module';
import { ScenariosModule } from './scenarios/scenarios.module';

@NgModule({
  imports: [CommonModule, EngagementModule, QuickRepliesModule, ScenariosModule],
})
export class CareModule {}
